// PurchaseDeliveryExportToExcel.jsx (formato tipo SHEET)
// IMPORTANTE: usamos la variante con estilos
import * as XLSX from "xlsx-js-style";

const BORDER_THIN = {
  top: { style: "thin", color: { rgb: "FFBFBFBF" } },
  left: { style: "thin", color: { rgb: "FFBFBFBF" } },
  bottom: { style: "thin", color: { rgb: "FFBFBFBF" } },
  right: { style: "thin", color: { rgb: "FFBFBFBF" } },
};

const HEADER_STYLE = {
  font: { bold: true },
  alignment: { horizontal: "center", vertical: "center", wrapText: true },
  fill: { fgColor: { rgb: "FFEFEFEF" } }, // gris claro
  border: BORDER_THIN,
};

const CELL_STYLE = {
  alignment: { vertical: "center" },
  border: BORDER_THIN,
};

const NUMBER_STYLE = {
  ...CELL_STYLE,
  numFmt: "0.00",
};

const exportToExcel = (data, fileName) => {
  const formatDate = (dateValue) => {
    if (!dateValue) return "";
    const d = new Date(dateValue);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const entradasData = (Array.isArray(data) ? data : []).flatMap((row) => {
    const albaranDetails = [
      row.purchasenote || "",
      formatDate(row.datepurchase) || "",
      row.opt_tras_tradename || "",
      row.opt_tras_licenseplate || "",
      row.vehicle_marca || "",
      row.vehicle_model || "",
      row.vehiclestore_frame || "",
    ];

    const lines = Array.isArray(row.linespurchasedelivery) ? row.linespurchasedelivery : [];
    return lines.map((line) => [
      ...albaranDetails,
      Number(line.amount ?? 0),
      Number(line.estimatedprice ?? 0),
      Number((line.amount ?? 0) * (line.estimatedprice ?? 0)),
      Number(((line.amount ?? 0) * (line.estimatedprice ?? 0)) * ((line.tax ?? 0) / 100)),
      Number(line.total ?? 0),
      Number(row.totalpurchasedelivery ?? 0),
      Number(row.totaldiscountpurchasedelivery ?? 0),
      Number(row.totaltaxespurchasedelivery ?? 0),
      Number(row.totalNetoPurchasedelivery ?? 0),
      row.payment_namees || "",
      line.article_code || "",
      line.article_namees || "",
    ]);
  });

  const headers = [
    "Nº ALBARÁN",
    "FECHA",
    "PROVEEDOR",
    "MATRÍCULA",
    "MARCA",
    "MODELO",
    "Nº BASTIDOR",
    "CANTIDAD",
    "PRECIO ESTIMADO",
    "IMPORTE",
    "IMPUESTO",
    "TOTAL",
    "IMPORTE ALBARÁN",
    "DESCUENTO ALBARÁN",
    "IMPUESTO ALBARÁN",
    "TOTAL ALBARÁN",
    "FORMA DE PAGO",
    "CÓDIGO ARTÍCULO",
    "DESCRIPCIÓN ARTÍCULO",
  ];

  const ws = XLSX.utils.aoa_to_sheet([headers, ...entradasData]);

  // Altura de encabezado y autofiltro
  ws["!rows"] = ws["!rows"] || [];
  ws["!rows"][0] = { hpt: 24 };
  ws["!autofilter"] = { ref: `A1:${XLSX.utils.encode_col(headers.length - 1)}1` };

  // Congelar encabezado
  ws["!freeze"] = { xSplit: 0, ySplit: 1 };

  // Aplicar estilos al encabezado
  for (let c = 0; c < headers.length; c++) {
    const addr = XLSX.utils.encode_cell({ r: 0, c });
    ws[addr] = ws[addr] || { t: "s", v: headers[c] };
    ws[addr].s = HEADER_STYLE;
  }

  // Estilos y tipado de datos
  const wsRange = XLSX.utils.decode_range(ws["!ref"]);
  // columnas numéricas: 7..15 (CANTIDAD hasta TOTAL ALBARÁN)
  const firstNumericCol = 7;
  const lastNumericCol = 15;

  for (let r = 1; r <= wsRange.e.r; r++) {
    for (let c = 0; c <= wsRange.e.c; c++) {
      const addr = XLSX.utils.encode_cell({ r, c });
      const cell = ws[addr];
      if (!cell) continue;

      // Estilo base
      cell.s = cell.s ? { ...CELL_STYLE, ...cell.s } : { ...CELL_STYLE };

      // Forzar numérico con 2 decimales en las columnas definidas
      if (c >= firstNumericCol && c <= lastNumericCol) {
        const val = Number(cell.v);
        if (!isNaN(val)) {
          cell.t = "n";
          cell.v = Math.round(val * 100) / 100;
          cell.z = "0.00";
          cell.s = { ...NUMBER_STYLE };
        }
      }
    }
  }

  // Autoajuste de anchos en función al contenido (máx 60)
  const allRows = [headers, ...entradasData];
  const colWidths = Array.from({ length: headers.length }, () => ({ wch: 10 }));
  for (let r = 0; r < allRows.length; r++) {
    for (let c = 0; c < headers.length; c++) {
      const v = allRows[r][c];
      const s = typeof v === "number" ? v.toFixed(2) : (v ?? "").toString();
      colWidths[c].wch = Math.max(colWidths[c].wch, Math.min(60, s.length + 2));
    }
  }
  ws["!cols"] = colWidths;

  // Libro y descarga
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "ALBARANES");
  const safeFileName = fileName?.endsWith(".xlsx") ? fileName : `${fileName || "ALBARANES"}.xlsx`;

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = safeFileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

export default exportToExcel;
